import { SampleDetailsLink } from "../../../../components";
import { route } from "../../../../shim/jsbridge";
import { isBlankOrHangulFiller } from "../../../../utils";

type Props = {
  id: string;
  fileName: string;
  sha1: string;
  sourceId: string;
  classification: string;
};

const ExtractedFilesFlatNameCell = ({
  fileName,
  id,
  classification,
  sha1,
  sourceId
}: Props) => {
  // check if filename contains any regular characters, otherwise replace it with hash value
  const displayName =
    !fileName || isBlankOrHangulFiller(fileName) ? sha1 : fileName;

  const sampleRecord = {
    sha1,
    threat_status: classification,
    classification,
    filename: sha1
  };

  return (
    <div className="flex flex-column">
      <SampleDetailsLink
        href={route(
          "samples_details_main",
          {
            hash_value: sha1,
            source_id: sourceId
          },
          { r: id }
        )}
        sampleRecord={sampleRecord}
        showTitle
      >
        {sha1}
      </SampleDetailsLink>
      <span
        className="sample-link no-expand overflow-ellipsis w-100"
        style={{ minWidth: "40px", fontSize: "12px", marginTop: "3px" }}
      >
        {displayName}
      </span>
    </div>
  );
};

export default ExtractedFilesFlatNameCell;
